import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class CustomerProjectService {
    constructor(http) {
        this.http = http;
        this.singular = 'customer project';
        this.plural = 'customer projects';
        this.editor = PLATFORM.moduleName('pages/standard-setup/customer-projects/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`customer-projects/filter/${loadOptions}`);
        return await response.json();
    }

    async create(customerProject) {
        const response = await this.http.fetch('customer-projects', { method: 'POST', body: json(customerProject) });
        return await response.json();
    }

    async update(customerProject) {
        await this.http.fetch(`customer-projects/${customerProject.id}`, { method: 'PUT', body: json(customerProject) });
    }

    async delete(id) {
        await this.http.fetch(`customer-projects/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`customer-projects/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`customer-projects/top-three/${query}`);
        return await response.json();
    }
}
